import React, {useState, useEffect, useRef, useContext} from 'react';
import {Form, Input, Button, Popover, Image, Spin, notification} from 'antd';
import {
    PlusOutlined,
    CompassOutlined,
    FileOutlined,
    FileImageOutlined,
    VideoCameraOutlined,
    MinusCircleOutlined,
} from '@/icons';
import styles from './msg.form.module.less';
import ActiveFormModal from '@/page/customer/MsgPage/Send/ActiveFormModal';
import MediaType from '@/page/app/MediaPage/MediaType';
import ReactPlayer from 'react-player';
import _ from 'lodash';
import {sendGroup} from '@/api/customer';
import UploadModal from '@/page/component/UploadModal';
import MsgContext from '@/page/customer/MsgPage/msgContext';

const {TextArea} = Input;

const attaches = [
    {
        value: '链接',
        icon: <CompassOutlined />,
        key: 0,
        msgType: 'LINK',
    },
    {
        value: '图片',
        icon: <FileImageOutlined />,
        key: 1,
        msgType: 'IMAGE',
    },
    {
        value: '视频',
        icon: <VideoCameraOutlined />,
        key: 2,
        msgType: 'VIDEO',
    },
    {
        value: '文件',
        icon: <FileOutlined />,
        key: 3,
        msgType: 'FILE',
    },
];

const buttonItemLayout = {wrapperCol: {span: 10}};
const formLayout = {
    labelCol: {span: 3, offset: 1},
    wrapperCol: {span: 10, offset: 1},
};

function MsgForm({sender, userIds, sendType, selectedUsers, editable = false}) {
    const wallModal = useRef();
    const formRef = useRef();
    useEffect(() => {}, []);
    const [visible, setVisible] = useState(false);
    const [pVisible, setPVisible] = useState(false);
    const [msgType, setMsgType] = useState({});
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [files, setFiles] = useState([]);
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(false);
    const {
        setCount,
        setUserIds,
        setSelectedUsers,
        setNames,
        setViewText,
        setViewLinks,
        setViewFiles,
        setViewImages,
        setViewVideos,
    } = useContext(MsgContext);

    function renderContent() {
        return (
            <div className={styles.attachContent}>
                {attaches.map(item => (
                    <div
                        className={styles.attachBlock}
                        key={item.key}
                        onClick={() => addForm(item.msgType)}
                    >
                        {item.value}
                    </div>
                ))}
            </div>
        );
    }

    function renderActiveItem(type = 0) {
        if (type === 0) {
            return images.map((item, i) => (
                <div className={styles.file} key={i}>
                    <Image
                        src={item.urls.file}
                        width={200}
                        height={100}
                        style={{objectFit: 'cover'}}
                    />
                    <MinusCircleOutlined onClick={() => remove(item)} className={styles.icon} />
                </div>
            ));
        } else if (type === 1) {
            // 视频
            return videos.map((item, i) => (
                <div className={styles.file} key={i}>
                    <ReactPlayer
                        controls
                        playing={false}
                        url={item.urls.file}
                        width={200}
                        height={100}
                    />
                    <MinusCircleOutlined onClick={() => remove(item, 1)} className={styles.icon} />
                </div>
            ));
        } else if (type === 2) {
            // 文件
            return files.map((item, i) => (
                <div className={styles.file} key={i}>
                    {item.fileName}&nbsp;&nbsp;
                    <MinusCircleOutlined onClick={() => remove(item, 2)} className={styles.icon} />
                </div>
            ));
        } else {
            return links.map((item, i) => (
                <div key={i} className={styles.file}>
                    {item.title}&nbsp;&nbsp;
                    <a href={item.url} target="_blank">
                        ({item.url})
                    </a>
                    &nbsp;&nbsp;
                    <MinusCircleOutlined
                        onClick={() => remove(item, 3, i)}
                        className={styles.icon}
                    />
                </div>
            ));
        }
    }

    function remove(item, type = 0, index = null) {
        let temp = [];
        if (type === 0) {
            temp = images.filter(file => file.id !== item.id);
            setImages(temp);
            setViewImages(temp);
        } else if (type === 1) {
            temp = videos.filter(file => file.id !== item.id);
            setVideos(temp);
            setViewVideos(temp);
        } else if (type === 2) {
            temp = files.filter(file => file.id !== item.id);
            setFiles(temp);
            setViewFiles(temp);
        } else {
            temp = links.filter((file, i) => i !== index);
            setLinks(temp);
            setViewLinks(temp);
        }
    }

    function onCreate(values) {
        let temp = links;
        temp.push(values);
        setLinks(temp);
        setViewLinks(temp);
        setVisible(false);
    }

    function limit() {
        const total = videos.length + links.length + images.length + files.length;
        if (total < 9) {
            return true;
        } else {
            return false;
        }
    }

    function onSubmit(val) {
        let multiFiles = [...files, ...images, ...videos];
        let linkArray = [];
        if (links.length > 0) {
            links.forEach(link => {
                linkArray.push({
                    msgtype: 'link',
                    link: {
                        title: link.title,
                        url: link.url,
                    },
                });
            });
        }
        if (sendType === 'singleCustomer') {
            let sendGroupMessageParam = {
                chat_type: 'single',
                text: val,
                sender: 'caoweid',
                external_userid: userIds,
                attachments: linkArray,
            };
            let sendGroupMessageVo = {
                sendGroupMessageParam: sendGroupMessageParam,
                sysAttaches: multiFiles,
            };
            setLoading(true);
            sendGroup(sendGroupMessageVo).then(res => {
                if (res.status === 200) {
                    if (res.data.errcode === 0)
                        notification.success({
                            message: '发送成功',
                        });
                    else
                        notification.error({
                            message: '发送失败',
                            description: (
                                <>
                                    <p>{'错误码：' + res.data.errcode}</p>
                                    <a
                                        href={
                                            'https://open.work.weixin.qq.com/devtool/query?e=' +
                                            res.data.errcode
                                        }
                                        target="_blank"
                                    >
                                        点击查询具体错误
                                    </a>
                                </>
                            ),
                        });
                }
                setLoading(false);
            });
        } else {
            if (userIds.length > 0) {
                for (let i = 0; i < userIds.length; i++) {
                    let sendGroupMessageParam = {
                        chat_type: sendType === 'group' ? 'group' : 'single',
                        text: val,
                        sender: userIds[i],
                        attachments: linkArray,
                    };
                    let sendGroupMessageVo = {
                        sendGroupMessageParam: sendGroupMessageParam,
                        sysAttaches: multiFiles,
                    };
                    console.log(sendGroupMessageVo);
                    sendGroup(sendGroupMessageVo).then(res => {
                        let num = i + 1;
                        if (res.data.errcode === 0) {
                            notification.success({
                                message: '发送成功',
                                description: (
                                    <p>
                                        {'第' + num + '条发送成功,发送人' + selectedUsers[i].name}
                                    </p>
                                ),
                            });
                        } else {
                            notification.error({
                                message: '发送失败',
                                description: (
                                    <>
                                        <p>{'错误码：' + res.data.errcode}</p>
                                        <a
                                            href={
                                                'https://open.work.weixin.qq.com/devtool/query?e=' +
                                                res.data.errcode
                                            }
                                            target="_blank"
                                        >
                                            点击查询具体错误
                                        </a>
                                    </>
                                ),
                            });
                        }
                    });
                }
            }
        }
    }

    function addForm(msgType) {
        if (limit()) {
            const tempType = msgType === 'LINK' ? {} : MediaType[msgType];
            setMsgType(tempType);
            if (msgType !== 'LINK') {
                onAddClick();
            } else {
                setVisible(true);
                setPVisible(false);
            }
        } else {
            notification.error({
                message: '最多添加9个附件',
            });
        }
    }

    function onAddClick() {
        wallModal.current.showModal();
        setPVisible(false);
    }

    function afterUpload(attachs) {
        console.log(attachs);
        if (_.isEmpty(attachs)) {
            return;
        }
        let temp = [];
        if (attachs[0].contentType === 'video/mp4') {
            temp = [...videos];
            temp.push(...attachs);
            setVideos(temp);
            setViewVideos(temp);
        } else if (attachs[0].contentType === 'image/jpeg') {
            temp = [...images];
            temp.push(...attachs);
            setImages(temp);
            setViewImages(temp);
        } else {
            temp = [...files];
            temp.push(...attachs);
            setFiles(temp);
            setViewFiles(temp);
        }
    }

    function afterCloseModal() {
        // reload && reload();
    }

    function handleVisibleChange(pVisible) {
        setPVisible(pVisible);
    }

    function onReset() {
        formRef.current.resetFields();
        setLinks([]);
        setVideos([]);
        setImages([]);
        setFiles([]);
        setViewLinks([]);
        setViewVideos([]);
        setViewImages([]);
        setViewFiles([]);
        setViewText(null);
        setCount(0);
        setNames('');
        setSelectedUsers([]);
        setUserIds([]);
    }

    function viewText(e) {
        setViewText(e.target.value);
    }

    return (
        <Spin spinning={loading}>
            <div className={styles.container}>
                <Form onFinish={onSubmit} layout="vertical" {...formLayout} ref={formRef}>
                    <Form.Item label="消息内容：" name="content">
                        <TextArea rows={10} onChange={viewText} />
                    </Form.Item>
                    {links.length > 0 && (
                        <Form.Item label="链接：">{<>{renderActiveItem(3)}</>}</Form.Item>
                    )}
                    {images.length > 0 && (
                        <Form.Item label="图片：">
                            {<div className={styles.renderBlock}>{renderActiveItem()}</div>}
                        </Form.Item>
                    )}
                    {videos.length > 0 && (
                        <Form.Item label="视频：">
                            {<div className={styles.renderBlock}>{renderActiveItem(1)}</div>}
                        </Form.Item>
                    )}
                    {files.length > 0 && (
                        <Form.Item label="文件：">{<>{renderActiveItem(2)}</>}</Form.Item>
                    )}
                    <Form.Item {...formLayout}>
                        <Popover
                            content={renderContent()}
                            title="选择附件类型「最多添加9个附件」"
                            trigger="click"
                            visible={pVisible}
                            onVisibleChange={handleVisibleChange}
                            placement="bottomLeft"
                        >
                            <Button type="dashed" icon={<PlusOutlined />} disabled={!editable}>
                                添加附件
                            </Button>
                        </Popover>
                    </Form.Item>
                    <Form.Item {...buttonItemLayout}>
                        <Button
                            disabled={!editable}
                            htmlType="button"
                            onClick={onReset}
                            style={{border: 0, background: '#eaeaea'}}
                        >
                            重置
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{marginLeft: '10px'}}
                            disabled={!editable}
                        >
                            提交
                        </Button>
                    </Form.Item>
                </Form>
                <ActiveFormModal
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onCreate={onCreate}
                />
                <UploadModal
                    ref={wallModal}
                    type={msgType}
                    category="sendGroup"
                    modalTitle={!_.isEmpty(msgType) ? `上传${msgType.label}素材` : ''}
                    afterUpload={afterUpload}
                    afterCloseModal={afterCloseModal}
                />
            </div>
        </Spin>
    );
}

export default MsgForm;
